(() => {
  'use strict';

  const initAlmaxiV2MenuMotion = () => {
    const drawer = document.querySelector('#t4s-menu-drawer');
    if (!drawer) return;

    drawer.classList.add('alm-v2-ready');
    let closeTimer;

    const resetSubmenus = () => {
      drawer.querySelectorAll('.alm-sub-open').forEach((item) => {
        item.classList.remove('alm-sub-open');
      });
    };

    document.addEventListener('click', (event) => {
      const opener = event.target.closest(
        '.t4s-push-menu-btn, [data-menu-drawer]'
      );

      if (opener && !drawer.contains(opener)) {
        clearTimeout(closeTimer);
        drawer.classList.remove('alm-drawer-open');

        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            drawer.classList.add('alm-drawer-open');
          });
        });

        return;
      }

      const submenuToggle = event.target.closest(
        '#menu-mb__ul .t4s-mb-nav__icon'
      );

      if (submenuToggle && drawer.contains(submenuToggle)) {
        const item = submenuToggle.closest(
          '.t4s-menu-item-has-children'
        );

        if (item) {
          requestAnimationFrame(() => {
            item.classList.toggle('alm-sub-open');
          });
        }

        return;
      }

      const closer = event.target.closest(
        '.t4s-drawer-menu__close, [data-drawer-close], .t4s-close-overlay'
      );

      if (
        closer &&
        drawer.classList.contains('alm-drawer-open')
      ) {
        clearTimeout(closeTimer);

        closeTimer = setTimeout(() => {
          drawer.classList.remove('alm-drawer-open');
          resetSubmenus();
        }, 360);
      }
    });
  };

  const initAlmaxiV2ReviewsMotion = () => {
    const section = document.querySelector(
      '#shopify-section-tiktok-v2-staging, [id$="__tiktok-v2-staging"]'
    );

    if (!section) return;

    const cards = Array.from(
      section.querySelectorAll('.almaxi-tt__review')
    );

    if (!cards.length) return;

    const reduceMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;

    cards.forEach((card, index) => {
      card.style.setProperty(
        '--alm-review-delay',
        `${index * 70}ms`
      );
    });

    /*
      Progressive enhancement:
      cards are hidden for reveal only AFTER this class is added
      by successfully-running JS.
    */
    section.classList.add('alm-v2-reviews-ready');

    if (
      reduceMotion ||
      !('IntersectionObserver' in window)
    ) {
      cards.forEach((card) => {
        card.classList.add('alm-v2-review-in');
      });
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          entry.target.classList.add(
            'alm-v2-review-in'
          );

          observer.unobserve(entry.target);
        });
      },
      {
        threshold: 0.16,
        rootMargin: '0px 0px -6% 0px'
      }
    );

    cards.forEach((card) => {
      observer.observe(card);
    });
  };

  const initAlmaxiPremiumMotionV2 = () => {
    initAlmaxiV2MenuMotion();
    initAlmaxiV2ReviewsMotion();
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initAlmaxiPremiumMotionV2,
      { once: true }
    );
  } else {
    initAlmaxiPremiumMotionV2();
  }
})();
